
import { Invoices } from "@/api";
import PageTitle from "@/components/common/PageTitle.vue";
import VCurrencyField from "@/components/forms/VCurrencyField.vue";
import moment from "moment";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const Auth = namespace("auth");

@Component({ components: { PageTitle, VCurrencyField } })
export default class ExpenseRatesPage extends Vue {
  @Auth.Getter("getUser") getUser!: any;

  pageHeaders = [{ icon: "", header: "Off-Site Rates" }];
  saving = false;
  effectiveFrom = moment().format("YYYY-MM-DD");
  rates: { [key: string]: number } = {
    customerTransportPerKm: 4,
    fuelPerKm: 4.5,
    sntPerNight: 184,
    dinnerPerNight: 150,
    breakfastPerNight: 120
  };

  rateFields = [
    { code: "sntPerNight", label: "SNT" },
    { code: "customerTransportPerKm", label: "Cost Per KM" },
    { code: "fuelPerKm", label: "Fuel Per KM" },
    { code: "dinnerPerNight", label: "Dinner Allowance" },
    { code: "breakfastPerNight", label: "Breakfast Allowance" }
  ];

  get buttonsArray(): Array<Record<string, string>> {
    if (!this.canManage) return [];
    return [
      {
        text: "Save",
        icon: "",
        color: "gray",
        action: "save"
      }
    ];
  }

  get canManage(): boolean {
    return Boolean(
      this.getUser &&
        this.getUser.permissions &&
        this.getUser.permissions.includes("manage_expense_rates")
    );
  }

  async created(): Promise<void> {
    await this.loadRates();
  }

  // The permission can land after this page is created, when the session is
  // restored from the API rather than from a fresh login.
  @Watch("canManage")
  async onCanManageChange(): Promise<void> {
    await this.loadRates();
  }

  async loadRates(): Promise<void> {
    if (!this.canManage) return;
    try {
      const rates = await Invoices.rates();
      const keys = new Map<string, string>([
        ["customer_transport_per_km", "customerTransportPerKm"],
        ["fuel_per_km", "fuelPerKm"],
        ["snt_per_night", "sntPerNight"],
        ["dinner_per_night", "dinnerPerNight"],
        ["breakfast_per_night", "breakfastPerNight"]
      ]);
      rates.forEach((rate: any) => {
        this.$set(
          this.rates,
          keys.get(rate.code) || rate.code,
          Number(rate.amount)
        );
        this.effectiveFrom = rate.effectiveFrom || this.effectiveFrom;
      });
    } catch (e) {
      await this.$error(e);
    }
  }

  async save(): Promise<void> {
    this.saving = true;
    try {
      await Invoices.updateRates({
        rates: this.rates,
        effectiveFrom: this.effectiveFrom
      });
      await this.$success(
        "<strong>Success!</strong> Off-site rates have been updated."
      );
    } catch (e) {
      await this.$error(e);
    } finally {
      this.saving = false;
    }
  }
}
